
export const alertSections = [
  {
    title: "Associe esse POS a um Estabelecimento de maneira avulsa",
    description: "Caso algo tenha acontecido com o POS ou deseje associar de maneira avulsa a um estabelecimento.",
    buttonText: 'Associar POS a Estabelecimento',
    buttonColor: 'bg-primary-blue',

  },
  {
    title: "O POS será bloqueado e ficará impedido de ser acessado e realizar transações",
    description: "Caso o POS esteja associado a um estabelecimento o mesmo não poderá utilizar o POS.",
    buttonText: 'Bloquear',
    buttonColor: 'bg-danger',
  },
  {
    title: "O POS será desbloqueado e ficará livre para ser acessado e realizar transações",
    description: "Caso o POS esteja associado a um estabelecimento o mesmo poderá utilizar o POS.",
    buttonText: 'Desbloquear POS',
    buttonColor: 'bg-primary-blue',
  }
];

export const infoBlocks = [
  {
    label: "Modelo POS",
  },
  {
    label: "Código do POS",
  },
  {
    label: "Estabelecimento",
  }
]